import { remToPx, pxToRem } from './size-utils.esm.js';

function getWebUnit (_value) {
  var basePx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  var value = Array.isArray(_value) ? _value[0] : undefined;
  return typeof value === 'string' && value.includes('rem') ? [remToPx(value, basePx), value] : typeof value === 'string' && value.includes('px') ? [value, pxToRem(value, basePx)] : ["".concat(value), 'Not Supported'];
}

export default getWebUnit;
//# sourceMappingURL=get-web-unit.esm.js.map
